if (!customElements.get('pp-colour-shop')) {
  customElements.define('pp-colour-shop', class PPColourShop extends HTMLElement {
    connectedCallback() {
      this.activeFilter = 'all';
      this.searchTerm = '';
      this.onClick = this.onClick.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onVariantAdded = this.onVariantAdded.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onInput);
      this.addEventListener('change', this.onChange);
      this.addEventListener('variant:add', this.onVariantAdded);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('variant:add', this.onVariantAdded);
    }

    onClick(event) {
      const quantityButton = event.target.closest('[data-pp-quantity-minus], [data-pp-quantity-plus]');
      if (quantityButton) {
        this.updateQuantity(quantityButton);
        return;
      }

      const filterButton = event.target.closest('[data-pp-filter]');
      if (filterButton) {
        this.activeFilter = filterButton.dataset.ppFilter;
        this.querySelectorAll('[data-pp-filter]').forEach((button) => {
          const active = button === filterButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.filterCards();
        return;
      }

      const scrollLink = event.target.closest('[data-pp-scroll-target]');
      if (scrollLink) {
        const target = document.getElementById(scrollLink.hash.slice(1));
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }

    onInput(event) {
      if (!event.target.matches('[data-pp-search]')) return;
      this.searchTerm = event.target.value.trim().toLowerCase();
      this.filterCards();
    }

    onChange(event) {
      if (!event.target.matches('[data-pp-quantity] input[name="quantity"]')) return;
      const value = Number.parseInt(event.target.value, 10);
      event.target.value = Number.isFinite(value) ? Math.max(1, value) : 1;
    }

    onVariantAdded(event) {
      const form = event.target.closest('.pp-colour-tile__form, .pp-paint-set-card__form');
      const button = form?.querySelector('.pp-colour-tile__add, .pp-paint-set-card__add');
      if (!button) return;
      const label = button.querySelector('span');
      window.clearTimeout(button.ppSuccessTimeout);
      button.classList.add('is-added');
      label.textContent = 'Added to Basket';
      button.ppSuccessTimeout = window.setTimeout(() => {
        button.classList.remove('is-added');
        label.textContent = button.dataset.defaultLabel;
      }, 1800);
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    updateQuantity(button) {
      const input = button.closest('[data-pp-quantity]')?.querySelector('input[name="quantity"]');
      if (!input) return;
      const currentValue = Number.parseInt(input.value, 10) || 1;
      input.value = button.hasAttribute('data-pp-quantity-plus') ? currentValue + 1 : Math.max(1, currentValue - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (!this.reducedMotion) {
        input.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.14)' }, { transform: 'scale(1)' }], { duration: 180, easing: 'ease-out' });
      }
    }

    filterCards() {
      let visibleCount = 0;
      this.querySelectorAll('[data-pp-variant-card]').forEach((card) => {
        const matchesSearch = !this.searchTerm || card.dataset.ppSearchData.includes(this.searchTerm);
        const opacity = card.dataset.ppOpacity || '';
        const matchesFilter = this.activeFilter === 'all' || opacity.includes(this.activeFilter);
        const visible = matchesSearch && matchesFilter;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      const counter = this.querySelector('[data-pp-visible-count]');
      const emptyState = this.querySelector('[data-pp-no-results]');
      if (counter) counter.textContent = visibleCount;
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    }
  });
}